import { Component, ErrorInfo, ReactNode } from "react";

interface AnalysisErrorBoundaryProps {
	children: ReactNode;
	fallback: ReactNode;
}

interface AnalysisErrorBoundaryState {
	hasError: boolean;
}

// Prevents an unexpected AI JSON shape from crashing the whole page
export class AnalysisErrorBoundary extends Component<AnalysisErrorBoundaryProps, AnalysisErrorBoundaryState> {
	state: AnalysisErrorBoundaryState = { hasError: false };

	static getDerivedStateFromError(): AnalysisErrorBoundaryState {
		return { hasError: true };
	}

	componentDidCatch(error: Error, info: ErrorInfo) {
		console.error("Analysis rendering error:", error, info.componentStack);
	}

	render() {
		if (this.state.hasError)
			return this.props.fallback;
		return this.props.children;
	}
}
